import Vue from 'vue'
import VueMatomo from 'vue-matomo'


export default (router) =>{

  Vue.use(VueMatomo, {

    host: '//stats.asistentemovistar.com.mx/',

    siteId: 2,

    trackerFileName: 'matomo',

    router: router,

    enableLinkTracking: true,

    requireConsent: false,

    trackInitialView: true,

    disableCookies: false,

    enableHeartBeatTimer: false,

    heartBeatTimerInterval: 15,

    debug: false,

    userId: undefined,

    cookieDomain: undefined,

    domains: undefined,

    preInitActions: []
  }); 
}
